import type { ItemId, Project, ScenarioId } from '@finsim/model';
import { displayOrder } from '../../entities/project';

/** Item rows in on-screen order (collapsed variants skipped), for J/K navigation. */
export function visibleRows(
  project: Project,
  collapsed: ReadonlySet<ScenarioId>,
): { itemId: ItemId; scenarioId: ScenarioId }[] {
  return project.scenarios.flatMap((s) =>
    collapsed.has(s.id)
      ? []
      : displayOrder(project, s.id).map((item) => ({ itemId: item.id, scenarioId: s.id })),
  );
}

/** The row `delta` steps from the current one (clamped); the first row when nothing is selected. */
export function stepRow<T extends { itemId: ItemId; scenarioId: ScenarioId }>(
  rows: readonly T[],
  current: { itemId: ItemId; scenarioId: ScenarioId } | null,
  delta: 1 | -1,
): T | undefined {
  if (rows.length === 0) return undefined;
  const index = current
    ? rows.findIndex((r) => r.itemId === current.itemId && r.scenarioId === current.scenarioId)
    : -1;
  if (index === -1) return delta === 1 ? rows[0] : rows.at(-1);
  return rows[Math.min(rows.length - 1, Math.max(0, index + delta))];
}
